(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2492],{

/***/ 6803:
/***/ (function(module) {

(function (global, factory) {
   true ? module.exports = factory() :
  0;
}(this, (function () {
  var example = 'image-Tb9Ew8CXIwaY6R1kjMvI0uRR-2000x3000-jpg';
  function parseAssetId(ref) {
    var ref$1 = ref.split('-');
    var id = ref$1[1];
    var dimensionString = ref$1[2];
    var format = ref$1[3];

    if (!id || !dimensionString || !format) {
      throw new Error(("Malformed asset _ref '" + ref + "'. Expected an id like \"" + example + "\"."));
    }

    var ref$2 = dimensionString.split('x');
    var imgWidthStr = ref$2[0];
    var imgHeightStr = ref$2[1];
    var width = +imgWidthStr;
    var height = +imgHeightStr;
    var isValidAssetId = isFinite(width) && isFinite(height);

    if (!isValidAssetId) {
      throw new Error(("Malformed asset _ref '" + ref + "'. Expected an id like \"" + example + "\"."));
    }

    return {
      id: id,
      width: width,
      height: height,
      format: format
    };
  }

  var isRef = function (src) {
    var source = src;
    return source ? typeof source._ref === 'string' : false;
  };

  var isAsset = function (src) {
    var source = src;
    return source ? typeof source._id === 'string' : false;
  };

  var isAssetStub = function (src) {
    var source = src;
    return source && source.asset ? typeof source.asset.url === 'string' : false;
  }; // Convert an asset-id, asset or image to an image record suitable for processing
  // eslint-disable-next-line complexity


  function parseSource(source) {
    if (!source) {
      return null;
    }

    var image;

    if (typeof source === 'string' && isUrl(source)) {
      // Someone passed an existing image url?
      image = {
        asset: {
          _ref: urlToId(source)
        }
      };
    } else if (typeof source === 'string') {
      // Just an asset id
      image = {
        asset: {
          _ref: source
        }
      };
    } else if (isRef(source)) {
      // We just got passed an asset directly
      image = {
        asset: source
      };
    } else if (isAsset(source)) {
      // If we were passed an image asset document
      image = {
        asset: {
          _ref: source._id || ''
        }
      };
    } else if (isAssetStub(source)) {
      // If we were passed a partial asset (`url`, but no `_id`)
      image = {
        asset: {
          _ref: urlToId(source.asset.url)
        }
      };
    } else if (typeof source.asset === 'object') {
      // Probably an actual image with materialized asset
      image = source;
    } else {
      // We got something that does not look like an image, or it is an image
      // that currently isn't sporting an asset.
      return null;
    }

    var img = source;

    if (img.crop) {
      image.crop = img.crop;
    }

    if (img.hotspot) {
      image.hotspot = img.hotspot;
    }

    return applyDefaults(image);
  }

  function isUrl(url) {
    return /^https?:\/\//.test(("" + url));
  }

  function urlToId(url) {
    var parts = url.split('/').slice(-1);
    return ("image-" + (parts[0])).replace(/\.([a-z]+)$/, '-$1');
  } // Mock crop and hotspot if image lacks it


  function applyDefaults(image) {
    if (image.crop && image.hotspot) {
      return image;
    } // We need to pad in default values for crop or hotspot


    var result = Object.assign({}, image);

    if (!result.crop) {
      result.crop = {
        left: 0,
        top: 0,
        bottom: 0,
        right: 0
      };
    }

    if (!result.hotspot) {
      result.hotspot = {
        x: 0.5,
        y: 0.5,
        height: 1.0,
        width: 1.0
      };
    }

    return result;
  }

  var SPEC_NAME_TO_URL_NAME_MAPPINGS = [['width', 'w'], ['height', 'h'], ['format', 'fm'], ['download', 'dl'], ['blur', 'blur'], ['sharpen', 'sharp'], ['invert', 'invert'], ['orientation', 'or'], ['minHeight', 'min-h'], ['maxHeight', 'max-h'], ['minWidth', 'min-w'], ['maxWidth', 'max-w'], ['quality', 'q'], ['fit', 'fit'], ['crop', 'crop'], ['saturation', 'sat'], ['auto', 'auto'], ['dpr', 'dpr'], ['pad', 'pad']];
  function urlForImage(options) {
    var spec = Object.assign({}, (options || {}));
    var source = spec.source;
    delete spec.source;
    var image = parseSource(source);

    if (!image) {
      throw new Error(("Unable to resolve image URL from source (" + (JSON.stringify(source)) + ")"));
    }

    var id = image.asset._ref || image.asset._id || '';
    var asset = parseAssetId(id); // Compute crop rect in terms of pixel coordinates in the raw source image

    var cropLeft = Math.round(image.crop.left * asset.width);
    var cropTop = Math.round(image.crop.top * asset.height);
    var crop = {
      left: cropLeft,
      top: cropTop,
      width: Math.round(asset.width - image.crop.right * asset.width - cropLeft),
      height: Math.round(asset.height - image.crop.bottom * asset.height - cropTop)
    }; // Compute hot spot rect in terms of pixel coordinates

    var hotSpotVerticalRadius = image.hotspot.height * asset.height / 2;
    var hotSpotHorizontalRadius = image.hotspot.width * asset.width / 2;
    var hotSpotCenterX = image.hotspot.x * asset.width;
    var hotSpotCenterY = image.hotspot.y * asset.height;
    var hotspot = {
      left: hotSpotCenterX - hotSpotHorizontalRadius,
      top: hotSpotCenterY - hotSpotVerticalRadius,
      right: hotSpotCenterX + hotSpotHorizontalRadius,
      bottom: hotSpotCenterY + hotSpotVerticalRadius
    }; // If irrelevant, or if we are requested to: don't perform crop/fit based on
    // the crop/hotspot.

    if (!(spec.rect || spec.focalPoint || spec.ignoreImageParams || spec.crop)) {
      spec = Object.assign({}, spec,
        fit({
          crop: crop,
          hotspot: hotspot
        }, spec));
    }

    return specToImageUrl(Object.assign({}, spec,
      {asset: asset}));
  } // eslint-disable-next-line complexity

  function specToImageUrl(spec) {
    var cdnUrl = spec.baseUrl || 'https://cdn.sanity.io';
    var filename = (spec.asset.id) + "-" + (spec.asset.width) + "x" + (spec.asset.height) + "." + (spec.asset.format);
    var baseUrl = cdnUrl + "/images/" + (spec.projectId) + "/" + (spec.dataset) + "/" + filename;
    var params = [];

    if (spec.rect) {
      // Only bother url with a crop if it actually crops anything
      var ref = spec.rect;
      var left = ref.left;
      var top = ref.top;
      var width = ref.width;
      var height = ref.height;
      var isEffectiveCrop = left !== 0 || top !== 0 || height !== spec.asset.height || width !== spec.asset.width;

      if (isEffectiveCrop) {
        params.push(("rect=" + left + "," + top + "," + width + "," + height));
      }
    }

    if (spec.bg) {
      params.push(("bg=" + (spec.bg)));
    }

    if (spec.focalPoint) {
      params.push(("fp-x=" + (spec.focalPoint.x)));
      params.push(("fp-y=" + (spec.focalPoint.y)));
    }

    var flip = [spec.flipHorizontal && 'h', spec.flipVertical && 'v'].filter(Boolean).join('');

    if (flip) {
      params.push(("flip=" + flip));
    } // Map from spec name to url param name, and allow using the actual param name as an alternative


    SPEC_NAME_TO_URL_NAME_MAPPINGS.forEach(function (mapping) {
      var specName = mapping[0];
      var param = mapping[1];

      if (typeof spec[specName] !== 'undefined') {
        params.push((param + "=" + (encodeURIComponent(spec[specName]))));
      } else if (typeof spec[param] !== 'undefined') {
        params.push((param + "=" + (encodeURIComponent(spec[param]))));
      }
    });

    if (params.length === 0) {
      return baseUrl;
    }

    return (baseUrl + "?" + (params.join('&')));
  }

  function fit(source, spec) {
    var cropRect;
    var imgWidth = spec.width;
    var imgHeight = spec.height; // If we are not constraining the aspect ratio, we'll just use the whole crop

    if (!(imgWidth && imgHeight)) {
      return {
        width: imgWidth,
        height: imgHeight,
        rect: source.crop
      };
    }

    var crop = source.crop;
    var hotspot = source.hotspot; // If we are here, that means aspect ratio is locked and fitting will be a bit harder

    var desiredAspectRatio = imgWidth / imgHeight;
    var cropAspectRatio = crop.width / crop.height;

    if (cropAspectRatio > desiredAspectRatio) {
      // The crop is wider than the desired aspect ratio. That means we are cutting from the sides
      var height = Math.round(crop.height);
      var width = Math.round(height * desiredAspectRatio);
      var top = Math.max(0, Math.round(crop.top)); // Center output horizontally over hotspot

      var hotspotXCenter = Math.round((hotspot.right - hotspot.left) / 2 + hotspot.left);
      var left = Math.max(0, Math.round(hotspotXCenter - width / 2)); // Keep output within crop

      if (left < crop.left) {
        left = crop.left;
      } else if (left + width > crop.left + crop.width) {
        left = crop.left + crop.width - width;
      }

      cropRect = {
        left: left,
        top: top,
        width: width,
        height: height
      };
    } else {
      // The crop is taller than the desired ratio, we are cutting from top and bottom
      var width$1 = crop.width;
      var height$1 = Math.round(width$1 / desiredAspectRatio);
      var left$1 = Math.max(0, Math.round(crop.left)); // Center output vertically over hotspot

      var hotspotYCenter = Math.round((hotspot.bottom - hotspot.top) / 2 + hotspot.top);
      var top$1 = Math.max(0, Math.round(hotspotYCenter - height$1 / 2)); // Keep output rect within crop

      if (top$1 < crop.top) {
        top$1 = crop.top;
      } else if (top$1 + height$1 > crop.top + crop.height) {
        top$1 = crop.top + crop.height - height$1;
      }

      cropRect = {
        left: left$1,
        top: top$1,
        width: width$1,
        height: height$1
      };
    }

    return {
      width: imgWidth,
      height: imgHeight,
      rect: cropRect
    };
  } // For backwards-compatibility

  var validFits = ['clip', 'crop', 'fill', 'fillmax', 'max', 'scale', 'min'];
  var validCrops = ['top', 'bottom', 'left', 'right', 'center', 'focalpoint', 'entropy'];
  var validAutoModes = ['format'];

  function isSanityClientLike(client) {
    return client ? typeof client.clientConfig === 'object' : false;
  }

  function rewriteSpecName(key) {
    var specs = SPEC_NAME_TO_URL_NAME_MAPPINGS;

    for (var i = 0, list = specs; i < list.length; i += 1) {
      var entry = list[i];

      var specName = entry[0];
      var param = entry[1];

      if (key === specName || key === param) {
        return specName;
      }
    }

    return key;
  }

  function urlBuilder(options) {
    // Did we get a SanityClient?
    var client = options;

    if (isSanityClientLike(client)) {
      // Inherit config from client
      var ref = client.clientConfig;
      var apiUrl = ref.apiHost;
      var projectId = ref.projectId;
      var dataset = ref.dataset;
      var apiHost = apiUrl || 'https://api.sanity.io';
      return new ImageUrlBuilder(null, {
        baseUrl: apiHost.replace(/^https:\/\/api\./, 'https://cdn.'),
        projectId: projectId,
        dataset: dataset
      });
    } // Or just accept the options as given


    return new ImageUrlBuilder(null, options);
  }
  var ImageUrlBuilder = function ImageUrlBuilder(parent, options) {
    this.options = parent ? Object.assign({}, (parent.options || {}),
      (options || {})) // Merge parent options
    : Object.assign({}, (options || {})); // Copy options
  };

  ImageUrlBuilder.prototype.withOptions = function withOptions (options) {
    var baseUrl = options.baseUrl || this.options.baseUrl;
    var newOptions = {
      baseUrl: baseUrl
    };

    for (var key in options) {
      if (options.hasOwnProperty(key)) {
        var specKey = rewriteSpecName(key);
        newOptions[specKey] = options[key];
      }
    }

    return new ImageUrlBuilder(this, Object.assign({}, {baseUrl: baseUrl},
      newOptions));
  }; // The image to be represented. Accepts a Sanity 'image'-document, 'asset'-document or
  // _id of asset. To get the benefit of automatic hot-spot/crop integration with the content
  // studio, the 'image'-document must be provided.


  ImageUrlBuilder.prototype.image = function image (source) {
    return this.withOptions({
      source: source
    });
  }; // Specify the dataset


  ImageUrlBuilder.prototype.dataset = function dataset (dataset$1) {
    return this.withOptions({
      dataset: dataset$1
    });
  }; // Specify the projectId


  ImageUrlBuilder.prototype.projectId = function projectId (projectId$1) {
    return this.withOptions({
      projectId: projectId$1
    });
  }; // Specify background color


  ImageUrlBuilder.prototype.bg = function bg (bg$1) {
    return this.withOptions({
      bg: bg$1
    });
  }; // Set DPR scaling factor


  ImageUrlBuilder.prototype.dpr = function dpr (dpr$1) {
    // A DPR of 1 is the default - so only include it if we have a different value
    return this.withOptions(dpr$1 && dpr$1 !== 1 ? {
      dpr: dpr$1
    } : {});
  }; // Specify the width of the image in pixels


  ImageUrlBuilder.prototype.width = function width (width$1) {
    return this.withOptions({
      width: width$1
    });
  }; // Specify the height of the image in pixels


  ImageUrlBuilder.prototype.height = function height (height$1) {
    return this.withOptions({
      height: height$1
    });
  }; // Specify focal point in fraction of image dimensions. Each component 0.0-1.0


  ImageUrlBuilder.prototype.focalPoint = function focalPoint (x, y) {
    return this.withOptions({
      focalPoint: {
        x: x,
        y: y
      }
    });
  };

  ImageUrlBuilder.prototype.maxWidth = function maxWidth (maxWidth$1) {
    return this.withOptions({
      maxWidth: maxWidth$1
    });
  };

  ImageUrlBuilder.prototype.minWidth = function minWidth (minWidth$1) {
    return this.withOptions({
      minWidth: minWidth$1
    });
  };

  ImageUrlBuilder.prototype.maxHeight = function maxHeight (maxHeight$1) {
    return this.withOptions({
      maxHeight: maxHeight$1
    });
  };

  ImageUrlBuilder.prototype.minHeight = function minHeight (minHeight$1) {
    return this.withOptions({
      minHeight: minHeight$1
    });
  }; // Specify width and height in pixels


  ImageUrlBuilder.prototype.size = function size (width, height) {
    return this.withOptions({
      width: width,
      height: height
    });
  }; // Specify blur between 0 and 100


  ImageUrlBuilder.prototype.blur = function blur (blur$1) {
    return this.withOptions({
      blur: blur$1
    });
  };

  ImageUrlBuilder.prototype.sharpen = function sharpen (sharpen$1) {
    return this.withOptions({
      sharpen: sharpen$1
    });
  }; // Specify the desired rectangle of the image


  ImageUrlBuilder.prototype.rect = function rect (left, top, width, height) {
    return this.withOptions({
      rect: {
        left: left,
        top: top,
        width: width,
        height: height
      }
    });
  }; // Specify the image format of the image. 'jpg', 'pjpg', 'png', 'webp'


  ImageUrlBuilder.prototype.format = function format (format$1) {
    return this.withOptions({
      format: format$1
    });
  };

  ImageUrlBuilder.prototype.invert = function invert (invert$1) {
    return this.withOptions({
      invert: invert$1
    });
  }; // Rotation in degrees 0, 90, 180, 270


  ImageUrlBuilder.prototype.orientation = function orientation (orientation$1) {
    return this.withOptions({
      orientation: orientation$1
    });
  }; // Compression quality 0-100


  ImageUrlBuilder.prototype.quality = function quality (quality$1) {
    return this.withOptions({
      quality: quality$1
    });
  }; // Make it a download link. Parameter is default filename.


  ImageUrlBuilder.prototype.forceDownload = function forceDownload (download) {
    return this.withOptions({
      download: download
    });
  }; // Flip image horizontally


  ImageUrlBuilder.prototype.flipHorizontal = function flipHorizontal () {
    return this.withOptions({
      flipHorizontal: true
    });
  }; // Flip image vertically


  ImageUrlBuilder.prototype.flipVertical = function flipVertical () {
    return this.withOptions({
      flipVertical: true
    });
  }; // Ignore crop/hotspot from image record, even when present


  ImageUrlBuilder.prototype.ignoreImageParams = function ignoreImageParams () {
    return this.withOptions({
      ignoreImageParams: true
    });
  };

  ImageUrlBuilder.prototype.fit = function fit (value) {
    if (validFits.indexOf(value) === -1) {
      throw new Error(("Invalid fit mode \"" + value + "\""));
    }

    return this.withOptions({
      fit: value
    });
  };

  ImageUrlBuilder.prototype.crop = function crop (value) {
    if (validCrops.indexOf(value) === -1) {
      throw new Error(("Invalid crop mode \"" + value + "\""));
    }

    return this.withOptions({
      crop: value
    });
  }; // Saturation


  ImageUrlBuilder.prototype.saturation = function saturation (saturation$1) {
    return this.withOptions({
      saturation: saturation$1
    });
  };

  ImageUrlBuilder.prototype.auto = function auto (value) {
    if (validAutoModes.indexOf(value) === -1) {
      throw new Error(("Invalid auto mode \"" + value + "\""));
    }

    return this.withOptions({
      auto: value
    });
  }; // Specify the number of pixels to pad the image


  ImageUrlBuilder.prototype.pad = function pad (pad$1) {
    return this.withOptions({
      pad: pad$1
    });
  }; // Gets the url based on the submitted parameters


  ImageUrlBuilder.prototype.url = function url () {
    return urlForImage(this.options);
  }; // Alias for url()


  ImageUrlBuilder.prototype.toString = function toString () {
    return this.url();
  };

  return urlBuilder;

})));
//# sourceMappingURL=image-url.umd.js.map


/***/ }),

/***/ 41127:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[slug]",
      function () {
        return __webpack_require__(77058);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 44904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* reexport */ PortableText; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@sanity/block-content-to-react/lib/BlockContent.js
var BlockContent = __webpack_require__(88863);
var BlockContent_default = /*#__PURE__*/__webpack_require__.n(BlockContent);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./lib/sanity.ts
var sanity = __webpack_require__(41697);
// EXTERNAL MODULE: ./modules/sanity/SanityImage.tsx
var SanityImage = __webpack_require__(88114);
// EXTERNAL MODULE: ./components/CallToActionSlider/CallToActionSlider.module.css
var CallToActionSlider_module = __webpack_require__(92139);
var CallToActionSlider_module_default = /*#__PURE__*/__webpack_require__.n(CallToActionSlider_module);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/CallToActionSlider/CallToActionSlider.tsx






var WORRY_SCORE_TEXT = [
    "Very often",
    "Often",
    "Sometimes",
    "Rarely",
    "Never"
];
var SLEEP_QUALITY_TEXT = [
    "Very poor",
    "Poor",
    "Moderate",
    "Great",
    "Excellent"
];
var MENTAL_HEALTH_QUALITY_SCORE_TEXT = [
    "Very Poor",
    "Poor",
    "Moderate",
    "Great",
    "Excellent"
];
function calculateMentalHealthQualityScore(sleepQuality, worryScore) {
    // Possible score range 0 - 4
    var mentalHealthQualityScore = Math.floor((worryScore + sleepQuality) / 2);
    console.log(mentalHealthQualityScore);
    if (worryScore < 2 || sleepQuality < 2) {
        mentalHealthQualityScore = 0;
    } else if (worryScore == 2) {
        mentalHealthQualityScore = 1;
    }
    return mentalHealthQualityScore;
}
function CallToActionSlider(param) {
    var href = param.href;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(0), sleepQuality = ref[0], setSleepQuality = ref[1];
    var ref1 = (0,react.useState)(0), worryScore = ref1[0], setWorryScore = ref1[1];
    var mentalHealthQualityScore = calculateMentalHealthQualityScore(sleepQuality, worryScore);
    var touched = worryScore > 0 || sleepQuality > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "p-6 sm:p-10 bg-dawnDark-700 rounded-xl",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("flex", "".concat(touched ? "justify-between" : "justify-center")),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "py-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-base font-semibold text-white sm:text-2xl font-inter",
                            children: touched ? "Mental Health Quality" : "Check Your Mental Health Quality"
                        })
                    }),
                    touched && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "px-4 py-2 bg-white bg-opacity-6 rounded-2xl",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-base font-semibold text-white uppercase sm:text-2xl font-inter",
                            children: MENTAL_HEALTH_QUALITY_SCORE_TEXT[mentalHealthQualityScore]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "space-y-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col justify-between space-y-2 sm:space-y-2 sm:flex-row sm:items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-base text-white sm:text-xl sm:leading-8 font-inter",
                                        children: "How Is Your Sleep?"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-base font-bold text-white sm:text-xl sm:leading-8 font-inter",
                                        children: SLEEP_QUALITY_TEXT[sleepQuality]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider, {
                                onChange: setSleepQuality,
                                value: sleepQuality,
                                min: 0,
                                max: 4
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-16 space-y-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col justify-between space-y-2 sm:space-y-2 sm:flex-row sm:items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-base text-white sm:text-xl sm:leading-8 font-inter",
                                        children: "How often do you feel worry?"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-base font-bold text-white sm:text-xl sm:leading-8 font-inter",
                                        children: WORRY_SCORE_TEXT[worryScore]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider, {
                                onChange: setWorryScore,
                                value: worryScore,
                                min: 0,
                                max: 4
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center mt-16",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: {
                        pathname: href !== null && href !== void 0 ? href : "/questionnaire",
                        query: {
                            utm_source: router.asPath
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "w-full px-8 py-4 text-center rounded-full sm:w-auto bg-gradient-to-tr from-dawnPurple-500 to-dawnOrange-500",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "font-sans text-sm font-medium leading-none tracking-widest text-white uppercase sm:text-base",
                            children: "Start Feeling Better"
                        })
                    })
                })
            })
        ]
    });
}
function Slider(param) {
    var value = param.value, min = param.min, max = param.max, onChange = param.onChange;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute w-full h-2 bg-white rounded bg-opacity-10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute h-2 rounded-l bg-gradient-to-r from-dawnPurple-500 to-dawnOrange-500",
                style: {
                    width: "".concat(100 / (max - min) * (value - min), "%")
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "range",
                className: "absolute appearance-none h-2 w-full bg-transparent ".concat((CallToActionSlider_module_default()).inputRange),
                value: value,
                min: min,
                max: max,
                onChange: function(event) {
                    return onChange(parseInt(event.target.value));
                }
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/PortableText/PortableText.tsx








function BlockNormal(param) {
    var text = param.text;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        children: text
    });
}
function BlockHeadingTwo(param) {
    var text = param.text, indexPosition = param.indexPosition;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
        className: classnames_default()("font-inter text-2xl font-semibold leading-8 md:text-4xl", {
            "mt-10": [
                "middle",
                "last"
            ].includes(indexPosition)
        }),
        children: text
    });
}
function BlockRenderer(param) {
    var props = param.props, blocks = param.blocks;
    var _node = props.node, _style = _node.style, style = _style === void 0 ? "normal" : _style;
    switch(style){
        case "h2":
            var h2Blocks = blocks.filter(function(block) {
                return block.style === style;
            });
            var index = h2Blocks.findIndex(function(block) {
                return block._key === props.node._key;
            });
            var indexPosition = index === 0 ? "first" : index === h2Blocks.length - 1 ? "last" : "middle";
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockHeadingTwo, {
                text: props.children,
                indexPosition: indexPosition
            });
        case "normal":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockNormal, {
                text: props.children
            });
        default:
            // @ts-expect-error
            return BlockContent_default().defaultSerializers.types.block(props);
    }
}
function ImageRenderer(param) {
    var props = param.props;
    var ref;
    // @ts-expect-error
    var imageUrl = (props === null || props === void 0 ? void 0 : (ref = props.node) === null || ref === void 0 ? void 0 : ref.asset) ? BlockContent_default().getImageUrl(props) : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
        className: "my-10",
        children: imageUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: imageUrl,
            alt: "",
            className: "rounded-xl"
        }) : "No image url yet. Try reloading the page."
    });
}
function buildInternalUrl(contentType, slug) {
    return "".concat(contentType === "post" ? "/blog/" : "/").concat(slug);
}
function InternalLinkExtendedRenderer(param) {
    var props = param.props;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var _node = props.node, contentType = _node.contentType, slug = _node.slug;
    var imageAsset;
    if (props === null || props === void 0 ? void 0 : (ref = props.node) === null || ref === void 0 ? void 0 : ref.mainImage) {
        imageAsset = props === null || props === void 0 ? void 0 : props.node.mainImage;
    } else if (props === null || props === void 0 ? void 0 : (ref1 = props.node) === null || ref1 === void 0 ? void 0 : ref1.introSection) {
        imageAsset = props.node.introSection.image;
    }
    var text = (props === null || props === void 0 ? void 0 : (ref2 = props.node) === null || ref2 === void 0 ? void 0 : ref2.excerpt) || (props === null || props === void 0 ? void 0 : (ref3 = props.node) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.introSection) === null || ref4 === void 0 ? void 0 : ref4.text);
    var title = (props === null || props === void 0 ? void 0 : (ref5 = props.node) === null || ref5 === void 0 ? void 0 : ref5.title) || "No title";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: buildInternalUrl(contentType, slug),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: "flex p-4 mt-4 space-x-6 border rounded group md:p-6 border-dawnDark-200",
            children: [
                imageAsset && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative h-24 overflow-hidden rounded w-22 md:w-34 md:h-28",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityImage/* default */.Z, {
                            image: imageAsset,
                            fill: true
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "font-inter",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-base font-semibold md:text-xl md:leading-8 font-inter group-hover:text-dawnPurple-500 line-clamp-1",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-dawnDark-400 line-clamp-3",
                            children: text
                        })
                    ]
                })
            ]
        })
    });
}
function ExternalLinkRendererAnnotation(param) {
    var props = param.props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: props.mark.href ? props.mark.href : "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: "text-dawnPurple-500 hover:underline",
            children: props.children[0]
        })
    });
}
function InternalLinkRendererAnnotation(param) {
    var props = param.props;
    var _mark = props.mark, contentType = _mark.contentType, slug = _mark.slug;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: buildInternalUrl(contentType, slug),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: "text-dawnPurple-500 hover:underline",
            children: props.children[0]
        })
    });
}
function ListRenderer(param) {
    var props = param.props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        children: props.children
    });
}
function ListItemRenderer(param) {
    var props = param.props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        children: props.children
    });
}
function CitationSourceReferenceAnnotationRenderer(param) {
    var props = param.props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "#citation-source-".concat(props.mark.citationSourceReference),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: "text-sm align-top",
            children: props.children
        })
    });
}
function CallToActionSliderRenderer(param) {
    var props = param.props;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToActionSlider, {
        href: (ref = props.node) === null || ref === void 0 ? void 0 : ref.href
    });
}
function createSerializers(param) {
    var blocks = param.blocks;
    return {
        types: {
            block: function(props) {
                return BlockRenderer({
                    props: props,
                    blocks: blocks
                });
            },
            image: function(props) {
                return ImageRenderer({
                    props: props
                });
            },
            internalLinkExtended: function(props) {
                return InternalLinkExtendedRenderer({
                    props: props
                });
            },
            callToActionSlider: function(props) {
                return CallToActionSliderRenderer({
                    props: props
                });
            }
        },
        marks: {
            internalLinkAnnotation: function(props) {
                return InternalLinkRendererAnnotation({
                    props: props
                });
            },
            externalLinkAnnotation: function(props) {
                return ExternalLinkRendererAnnotation({
                    props: props
                });
            },
            citationSourceReferenceAnnotation: function(props) {
                return CitationSourceReferenceAnnotationRenderer({
                    props: props
                });
            }
        },
        listItem: function(props) {
            return ListItemRenderer({
                props: props
            });
        },
        list: function(props) {
            return ListRenderer({
                props: props
            });
        }
    };
}
function PortableText(param) {
    var blocks = param.blocks;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((BlockContent_default()), {
        projectId: sanity/* config.projectId */.vc.projectId,
        dataset: sanity/* config.dataset */.vc.dataset,
        serializers: createSerializers({
            blocks: blocks
        }),
        blocks: blocks,
        imageOptions: {
            w: 672,
            fit: "max"
        }
    });
}

;// CONCATENATED MODULE: ./components/PortableText/index.ts



/***/ }),

/***/ 59099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* reexport */ PreviewExitButton; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/PreviewExitButton/PreviewExitButton.tsx



function PreviewExitButton() {
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "fixed right-0 z-10 px-2 py-2 bg-white rounded-bl bg-opacity-10",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/api/exit-preview?redirect=".concat(router.asPath),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "text-xl font-bold cursor-pointer",
                    children: "Exit preview"
                })
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/PreviewExitButton/index.ts



/***/ }),

/***/ 41697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$r": function() { return /* binding */ usePreviewSubscription; },
/* harmony export */   "i3": function() { return /* binding */ sanityClient; },
/* harmony export */   "vc": function() { return /* binding */ config; }
/* harmony export */ });
/* unused harmony export useCurrentUser */
/* harmony import */ var next_sanity__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81035);

var config = {
    projectId: "4jrvqlog",
    dataset: "production",
    apiVersion: "2021-07-21",
    useCdn: "production" === "production"
};
var usePreviewSubscription = (0,next_sanity__WEBPACK_IMPORTED_MODULE_0__/* .createPreviewSubscriptionHook */ .KF)(config);
var useCurrentUser = (0,next_sanity__WEBPACK_IMPORTED_MODULE_0__/* .createCurrentUserHook */ .Iy)(config);
var sanityClient = (0,next_sanity__WEBPACK_IMPORTED_MODULE_0__/* .createClient */ .eI)(config);


/***/ }),

/***/ 41438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "qG": function() { return /* binding */ PostPreviewReadMore; },
/* harmony export */   "rJ": function() { return /* binding */ PostPreviewListItem; },
/* harmony export */   "sC": function() { return /* binding */ PostPreviewFeatured; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_Link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(504);
/* harmony import */ var modules_sanity_SanityImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88114);
/* harmony import */ var modules_blog_PostPublishedAtReadTime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51339);




function PostPreviewWrapper(param) {
    var children = param.children, post = param.post, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Link__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .r, {
        href: "/blog/".concat(post.slug.current),
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            className: "flex cursor-pointer w-full max-w-sm group ".concat(className),
            children: children
        })
    });
}
function PostPreviewListItem(param) {
    var post = param.post;
    if (!post) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(PostPreviewWrapper, {
        post: post,
        className: "flex flex-col w-full max-w-sm cursor-pointer md:flex-row md:items-center md:max-w-2xl xl:max-w-3xl md:space-x-6 group",
        children: [
            post.mainImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative w-full overflow-hidden rounded-xl md:w-1/3 h-44 xl:h-52",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_sanity_SanityImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        image: post.mainImage,
                        fill: true,
                        className: "transition duration-300 ease-in-out group-hover:transform group-hover:scale-110"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute hidden w-full h-full bg-white group-hover:block opacity-20"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex-1 mt-6 md:mt-0",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_blog_PostPublishedAtReadTime__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        publishedAt: post.publishedAt,
                        readTime: post.readTime
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mt-2 text-xl font-semibold md:mt-2 xl:text-2xl xl:leading-8 group-hover:text-dawnPurple-500",
                        children: post.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mt-2 text-base xl:text-xl xl:leading-8 font-inter max-h-24",
                        children: post.excerpt || "Missing excerpt"
                    })
                ]
            })
        ]
    });
}
function PostPreviewFeatured(param) {
    var post = param.post;
    if (!post) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(PostPreviewWrapper, {
        post: post,
        className: "flex flex-col w-full max-w-sm cursor-pointer md:flex-row md:items-center md:max-w-3xl xl:max-w-5xl md:space-x-12 group",
        children: [
            post.mainImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative w-full overflow-hidden rounded-xl md:w-1/2 h-80 xl:h-100",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_sanity_SanityImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        image: post.mainImage,
                        fill: true,
                        className: "transition duration-300 ease-in-out group-hover:transform group-hover:scale-110"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute hidden w-full h-full bg-white group-hover:block opacity-20"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex-1 mt-8 md:mt-0",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_blog_PostPublishedAtReadTime__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        publishedAt: post.publishedAt,
                        readTime: post.readTime
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mt-2 text-3xl font-semibold text-white xl:text-4xl xl:leading-12 group-hover:text-dawnPurple-500",
                        children: post.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mt-2 text-white font-inter xl:text-xl xl:leading-8",
                        children: post.excerpt || "Missing excerpt"
                    })
                ]
            })
        ]
    });
}
function PostPreviewReadMore(param) {
    var post = param.post;
    if (!post) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(PostPreviewWrapper, {
        post: post,
        className: "flex flex-col max-w-xs group",
        children: [
            post.mainImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative w-full overflow-hidden h-62 rounded-xl",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_sanity_SanityImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        image: post.mainImage,
                        fill: true,
                        className: "transition duration-300 ease-in-out group-hover:transform group-hover:scale-110"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute hidden w-full h-full bg-white group-hover:block opacity-20"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex-1 mt-6",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_blog_PostPublishedAtReadTime__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        publishedAt: post.publishedAt,
                        readTime: post.readTime
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mt-4 text-xl font-semibold md:text-2xl group-hover:text-dawnPurple-500",
                        children: post.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mt-4 text-base tracking-wide md:leading-8 md:text-lg font-inter",
                        children: post.excerpt || ""
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 51339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PostPublishedAtReadTime; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js + 1 modules
var parseISO = __webpack_require__(78420);
// EXTERNAL MODULE: ./node_modules/date-fns-tz/esm/utcToZonedTime/index.js
var utcToZonedTime = __webpack_require__(47951);
// EXTERNAL MODULE: ./node_modules/date-fns-tz/esm/format/index.js + 34 modules
var format = __webpack_require__(94559);
;// CONCATENATED MODULE: ./utils/date-utils.ts

var DEFAULT_DATE_FORMATS = {
    time: "h:mm a",
    date: "MMMM d, yyyy",
    dateDayMonth: "MMMM d",
    dateTime: "MMMM d, h:mm a",
    hour: "h a"
};
function dateParseISOFromTimezone(date) {
    var d = date.split(/\D/).map(function(d) {
        return parseInt(d);
    });
    return new Date(d[0], d[1] - 1, d[2], d[3], d[4], d[5]);
}
function dateFormat(date, options) {
    var formatStr;
    if (options === null || options === void 0 ? void 0 : options.formatStr) {
        // Try default formats first
        formatStr = DEFAULT_DATE_FORMATS[options.formatStr] ? DEFAULT_DATE_FORMATS[options.formatStr] : options.formatStr;
    } else {
        formatStr = DEFAULT_DATE_FORMATS.date;
    }
    if (options === null || options === void 0 ? void 0 : options.timeZone) {
        date = (0,utcToZonedTime/* default */.Z)(date, options.timeZone);
        return (0,format/* default */.Z)(date, formatStr, {
            timeZone: options.timeZone
        });
    }
    return (0,format/* default */.Z)(date, formatStr);
}

;// CONCATENATED MODULE: ./modules/blog/PostPublishedAtReadTime.tsx



function PostPublishedAtReadTime(param) {
    var publishedAt = param.publishedAt, readTime = param.readTime;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "text-sm font-medium tracking-widest uppercase md:text-base md:leading-4 text-dawnDark-300",
        children: [
            publishedAt ? dateFormat((0,parseISO/* default */.Z)(publishedAt), {
                formatStr: "MMM d, yyyy"
            }) : "",
            " \u2022 ",
            readTime || "",
            " min read"
        ]
    });
};


/***/ }),

/***/ 88114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SanityImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_sanity_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61202);
/* harmony import */ var lib_sanity__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41697);






function SanityImage(param) {
    var image = param.image, className = param.className, _fill = param.fill, fill = _fill === void 0 ? false : _fill, _width = param.width, width = _width === void 0 ? 800 : _width, _sizes = param.sizes, sizes = _sizes === void 0 ? "(max-width: 800px) 100vw, 800px" : _sizes;
    var imageProps = (0,next_sanity_image__WEBPACK_IMPORTED_MODULE_2__/* .useNextSanityImage */ .J)(lib_sanity__WEBPACK_IMPORTED_MODULE_3__/* .sanityClient */ .i3, image, {
        imageBuilder: function(imageUrlBuilder, options) {
            return imageUrlBuilder.width(Math.min(width, options.width));
        }
    });
    return fill ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        src: imageProps.src,
        alt: image.alt,
        loader: imageProps.loader,
        layout: "fill",
        sizes: sizes,
        objectFit: "cover",
        className: className
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, imageProps), {
        alt: image.alt,
        layout: "responsive",
        sizes: sizes,
        className: className
    }));
};


/***/ }),

/***/ 77058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ BlogPost; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./lib/sanity.ts
var sanity = __webpack_require__(41697);
// EXTERNAL MODULE: ./node_modules/@sanity/image-url/lib/browser/image-url.umd.js
var image_url_umd = __webpack_require__(6803);
var image_url_umd_default = /*#__PURE__*/__webpack_require__.n(image_url_umd);
;// CONCATENATED MODULE: ./lib/sanityImageUrl.ts


var imageBuilder = image_url_umd_default()(sanity/* sanityClient */.i3);
function sanityImageBuilder(source) {
    return imageBuilder.image(source);
};

// EXTERNAL MODULE: ./modules/sanity/SanityImage.tsx
var SanityImage = __webpack_require__(88114);
// EXTERNAL MODULE: ./components/PortableText/index.ts + 2 modules
var PortableText = __webpack_require__(44904);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/groq/lib/groq.js
var groq = __webpack_require__(12870);
var groq_default = /*#__PURE__*/__webpack_require__.n(groq);
;// CONCATENATED MODULE: ./groq-queries/blogPost.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '*[_type == \'post\' && slug.current == $slug][0]{ ..., "authors": authors[].teamMember->, "readMorePosts": readMorePosts[].post->, body[] {..., markDefs[] { ...,  _type == "internalLinkAnnotation" => { "contentType": @.reference->_type,  "slug": @.reference->slug.current, "title": @.reference->title, "excerpt": @.reference->excerpt  } }} }'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "*[_type == 'post' && defined(slug) && publishedAt < now()]{ slug }"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var blogPostQuery = groq_default()(_templateObject());
var blogPostPathsQuery = groq_default()(_templateObject1());

// EXTERNAL MODULE: ./components/PreviewExitButton/index.ts + 1 modules
var PreviewExitButton = __webpack_require__(59099);
// EXTERNAL MODULE: ./components/Navbar/Navbar.tsx + 6 modules
var Navbar = __webpack_require__(92595);
;// CONCATENATED MODULE: ./hooks/useScrollPosition.ts
// https://github.com/n8tb1t/use-scroll-position

var useIsomorphicLayoutEffect =  true ? react.useLayoutEffect : 0;
var isBrowser = "object" !== "undefined";
var zeroPosition = {
    x: 0,
    y: 0
};
var getClientRect = function(element) {
    return element === null || element === void 0 ? void 0 : element.getBoundingClientRect();
};
var getScrollPosition = function(param) {
    var element = param.element, useWindow = param.useWindow, boundingElement = param.boundingElement;
    if (!isBrowser) {
        return zeroPosition;
    }
    if (useWindow) {
        return {
            x: window.scrollX,
            y: window.scrollY
        };
    }
    var targetPosition = getClientRect((element === null || element === void 0 ? void 0 : element.current) || document.body);
    var containerPosition = getClientRect(boundingElement === null || boundingElement === void 0 ? void 0 : boundingElement.current);
    if (!targetPosition) {
        return zeroPosition;
    }
    return containerPosition ? {
        x: (containerPosition.x || 0) - (targetPosition.x || 0),
        y: (containerPosition.y || 0) - (targetPosition.y || 0)
    } : {
        x: targetPosition.left,
        y: targetPosition.top
    };
};
var useScrollPosition = function(effect, deps, element, useWindow, wait, boundingElement) {
    var position = (0,react.useRef)(getScrollPosition({
        useWindow: useWindow,
        boundingElement: boundingElement
    }));
    var throttleTimeout = null;
    var callBack = function() {
        var currPos = getScrollPosition({
            element: element,
            useWindow: useWindow,
            boundingElement: boundingElement
        });
        effect({
            prevPos: position.current,
            currPos: currPos
        });
        position.current = currPos;
        throttleTimeout = null;
    };
    useIsomorphicLayoutEffect(function() {
        if (!isBrowser) {
            return undefined;
        }
        var handleScroll = function() {
            if (wait) {
                if (throttleTimeout === null) {
                    throttleTimeout = window.setTimeout(callBack, wait);
                }
            } else {
                callBack();
            }
        };
        if (boundingElement) {
            var ref;
            (ref = boundingElement.current) === null || ref === void 0 ? void 0 : ref.addEventListener("scroll", handleScroll, {
                passive: true
            });
        } else {
            window.addEventListener("scroll", handleScroll, {
                passive: true
            });
        }
        return function() {
            if (boundingElement) {
                var ref;
                (ref = boundingElement.current) === null || ref === void 0 ? void 0 : ref.removeEventListener("scroll", handleScroll);
            } else {
                window.removeEventListener("scroll", handleScroll);
            }
            if (throttleTimeout) {
                clearTimeout(throttleTimeout);
            }
        };
    }, deps);
};
useScrollPosition.defaultProps = {
    deps: [],
    element: false,
    useWindow: false,
    wait: null,
    boundingElement: false
};

;// CONCATENATED MODULE: ./modules/blog/PostProgressbar.tsx



function PostProgressbar(param) {
    var startingRef = param.startingRef;
    var ref = (0,react.useState)(0), progress = ref[0], setProgress = ref[1];
    useScrollPosition(function(param) {
        var currPos = param.currPos;
        var ref;
        var position = currPos.y - window.innerHeight / 2;
        var height = startingRef === null || startingRef === void 0 ? void 0 : (ref = startingRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight;
        if (position < 0) {
            setProgress(Math.min(100, Number((Math.abs(position) / height * 100).toFixed(1))));
        } else {
            setProgress(0);
        }
    }, [], startingRef);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full h-1 bg-white rounded-full bg-opacity-10",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "absolute top-0 left-0 h-full rounded-full bg-gradient-to-r from-dawnOrange-500 to-dawnPurple-500",
            style: {
                width: "".concat(progress, "%"),
                transition: "width .2s"
            }
        })
    });
}

// EXTERNAL MODULE: ./modules/blog/PostPublishedAtReadTime.tsx + 1 modules
var PostPublishedAtReadTime = __webpack_require__(51339);
;// CONCATENATED MODULE: ./modules/blog/PostTitle.tsx



function PostTitle(param) {
    var title = param.title, publishedAt = param.publishedAt, readTime = param.readTime, author = param.author;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "mt-4 text-3.5xl font-semibold leading-10 lg:text-4xl xl:text-5xl lg:leading-14 xl:leading-14",
                children: title || "untitled"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center mt-4 space-x-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-12 h-12 ",
                        children: (author === null || author === void 0 ? void 0 : author.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityImage/* default */.Z, {
                            image: author.image,
                            width: 100,
                            className: "rounded-full"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "md:text-xl",
                                children: (author === null || author === void 0 ? void 0 : author.nameWithCredentials) || (author === null || author === void 0 ? void 0 : author.name) || ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostPublishedAtReadTime/* default */.Z, {
                                    publishedAt: publishedAt,
                                    readTime: readTime
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./modules/blog/PostCitationSources.tsx


function PostCitationSources(param) {
    var sources = param.sources;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "text-xl font-semibold",
                children: "References"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                className: "mt-4 list-decimal",
                children: sources.map(function(source, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        id: "citation-source-".concat(source.id),
                        className: "mb-3 ml-4 break-all",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PortableText/* PortableText */.Y, {
                            blocks: source.text
                        })
                    }, index);
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@sanity/block-content-to-react/lib/BlockContent.js
var lib_BlockContent = __webpack_require__(88863);
var BlockContent_default = /*#__PURE__*/__webpack_require__.n(lib_BlockContent);
;// CONCATENATED MODULE: ./modules/sanity/SanityPortableText.tsx


function SanityPortableText_PortableText(param) {
    var blocks = param.blocks, _serializers = param.serializers, serializers = _serializers === void 0 ? {} : _serializers;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((BlockContent_default()), {
        projectId: "4jrvqlog",
        dataset: "production",
        serializers: serializers,
        blocks: blocks
    });
};

;// CONCATENATED MODULE: ./modules/blog/PostAuthors.tsx



function PostAuthors(param) {
    var authors = param.authors;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: authors.map(function(author) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col md:space-x-4 md:flex-row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-20 h-20 overflow-hidden rounded-full md:rounded-none md:w-40 md:h-40",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityImage/* default */.Z, {
                            image: author.image,
                            width: 200
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-4 md:mt-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-base font-semibold",
                                children: author.nameWithCredentials || author.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-1 text-base md:text-lg md:leading-8 md:mt-2 font-inter",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityPortableText_PortableText, {
                                    blocks: author.bio,
                                    serializers: {
                                        types: {
                                            block: function(props) {
                                                var style = props.node.style;
                                                if (style === "normal") {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "mb-2",
                                                        children: props.children
                                                    });
                                                }
                                                // @ts-expect-error
                                                return BlockContent.defaultSerializers.types.block(props);
                                            }
                                        }
                                    }
                                })
                            })
                        ]
                    })
                ]
            }, author._id);
        })
    });
};

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/icons/IconFacebook.tsx
var IconFacebook = __webpack_require__(12337);
// EXTERNAL MODULE: ./components/icons/IconTwitter.tsx
var IconTwitter = __webpack_require__(22971);
;// CONCATENATED MODULE: ./components/icons/IconUrl.tsx

function IconUrl() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2",
            d: "M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
        })
    });
};

;// CONCATENATED MODULE: ./modules/blog/PostShareButtons.tsx






function PostShareButton(param) {
    var actionText = param.actionText, action = param.action, icon = param.icon, isSmallScreen = param.isSmallScreen;
    var wrapperHref = function wrapperHref() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: action.url,
            target: "_blank",
            rel: "noreferrer",
            "aria-label": actionText,
            className: !isSmallScreen ? largeScreenWrapperClassName : "",
            children: body
        });
    };
    var wrapperCopyToClipboard = function wrapperCopyToClipboard() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            onClick: function() {
                setLinkHasBeenCopied(true);
                var element = document.createElement("textarea");
                element.value = action.url;
                document.body.appendChild(element);
                element.select();
                document.execCommand("copy");
                document.body.removeChild(element);
            },
            "aria-label": actionText,
            className: !isSmallScreen ? largeScreenWrapperClassName : "",
            children: body
        });
    };
    var ref = (0,react.useState)(false), linkHasBeenCopied = ref[0], setLinkHasBeenCopied = ref[1];
    (0,react.useEffect)(function() {
        if (linkHasBeenCopied) {
            setTimeout(function() {
                setLinkHasBeenCopied(false);
            }, 1000);
        }
    }, [
        linkHasBeenCopied
    ]);
    var body = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    "aria-hidden": "true",
                    className: "w-6 h-6",
                    children: icon
                })
            }),
            !isSmallScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-sm text-transparent font-inter group-hover:text-white",
                children: linkHasBeenCopied ? "Link copied!" : actionText
            })
        ]
    });
    var largeScreenWrapperClassName = "flex items-center space-x-2 w-full px-3 py-2 hover:text-white hover:bg-dawnDark-700 rounded-full group";
    return action.actionType === "href" ? wrapperHref() : wrapperCopyToClipboard();
}
function PostShareButtons(param) {
    var title = param.title, _isSmallScreen = param.isSmallScreen, isSmallScreen = _isSmallScreen === void 0 ? false : _isSmallScreen;
    var router = (0,next_router.useRouter)();
    var url = "https://www.dawn.health".concat(router.asPath);
    var twitterText = encodeURIComponent("".concat(title, " by @dawnhealthapp ").concat(url));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex ".concat(isSmallScreen ? "flex-row space-x-6" : "flex-col space-y-6"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PostShareButton, {
                actionText: "Share on Facebook",
                action: {
                    url: "https://facebook.com/sharer/sharer.php?u=".concat(encodeURIComponent(url)),
                    actionType: "href"
                },
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconFacebook/* default */.Z, {}),
                isSmallScreen: isSmallScreen
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PostShareButton, {
                actionText: "Share on Twitter",
                action: {
                    url: "https://twitter.com/intent/tweet/?text=".concat(twitterText),
                    actionType: "href"
                },
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconTwitter/* default */.Z, {}),
                isSmallScreen: isSmallScreen
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PostShareButton, {
                actionText: "Copy to clipboard",
                action: {
                    url: url,
                    actionType: "copyToClipboard"
                },
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconUrl, {}),
                isSmallScreen: isSmallScreen
            })
        ]
    });
};

// EXTERNAL MODULE: ./modules/blog/PostPreview.tsx
var PostPreview = __webpack_require__(41438);
;// CONCATENATED MODULE: ./modules/blog/PostReadMore.tsx


function PostReadMore(param) {
    var posts = param.posts;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex justify-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "ml-6 text-3.5xl leading-10 md:text-5xl md:leading-12 font-semibold",
                    children: "Read more"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col mx-6 mt-2 space-y-8 md:space-y-0 md:flex-row md:space-x-8 md:mt-8",
                    children: posts.map(function(post) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PostPreview/* PostPreviewReadMore */.qG, {
                            post: post
                        }, post._id);
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/page-sections/CallToAction/index.ts + 1 modules
var CallToAction = __webpack_require__(31437);
;// CONCATENATED MODULE: ./pages/blog/[slug].tsx

















var __N_SSG = true;
// import { CallToActionStickyBottom } from 'components/page-sections/CallToActionStickyBottom/CallToActionStickyBottom';
function BlogPost(param) {
    var data = param.data, preview = param.preview;
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,sanity/* usePreviewSubscription */.$r)(blogPostQuery, {
        params: {
            slug: (ref = data.post) === null || ref === void 0 ? void 0 : ref.slug.current
        },
        initialData: data.post,
        enabled: preview && ((ref1 = data.post) === null || ref1 === void 0 ? void 0 : ref1.slug)
    }), post = ref5.data;
    var postRef = (0,react.useRef)(null);
    var title = post.metaTitle ? post.metaTitle : "".concat(post.title, " | Dawn Health");
    var postMainImageTwitterSource = "https://www.dawn.health/images/social_media/share-twitter.jpg";
    var postMainImageOpenGraphSource = "https://www.dawn.health/images/social_media/share-open-graph.jpg";
    if (post.mainImage) {
        var postMainImageUrl = sanityImageBuilder(post.mainImage);
        postMainImageTwitterSource = postMainImageUrl.width(800).height(418).url();
        postMainImageOpenGraphSource = postMainImageUrl.width(1200).height(627).url();
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: post.description
                    }, "description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }, "title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "og:description",
                        content: post.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "og:image",
                        content: postMainImageOpenGraphSource
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "og:url",
                        content: "https://www.dawn.health"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "og:site_name",
                        content: "Dawn Health"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "og:locale",
                        content: "en_US"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: title
                    }, "title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: post.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:site",
                        content: "Dawn Health"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@dawnhealth"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image:src",
                        content: postMainImageTwitterSource
                    })
                ]
            }),
            preview && /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewExitButton/* PreviewExitButton */.G, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: "min-h-screen text-dawnDark-500",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {
                        className: "sticky top-0 z-10 bg-dawnDark-700",
                        ctaInHeader: false,
                        ctaText: "Take your sleep quiz"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sticky z-10 lg:top-28 top-20",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostProgressbar, {
                            startingRef: postRef
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-center pt-6 mx-6 md:mx0 md:pt-12",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "sticky self-start hidden mt-4 mr-16 -ml-48 xl:block top-40",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostShareButtons, {
                                    title: post.title,
                                    description: post.description
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex-1 max-w-2xl",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PostTitle, {
                                        title: post.title,
                                        publishedAt: post.publishedAt,
                                        readTime: post.readTime,
                                        author: ((ref2 = post.authors) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 ? post.authors[0] : null
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-6 xl:hidden",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostShareButtons, {
                                            title: post.title,
                                            description: post.description,
                                            isSmallScreen: true
                                        })
                                    }),
                                    post.mainImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "relative w-full h-64 mt-6 md:h-96 children:rounded-xl",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityImage/* default */.Z, {
                                            image: post.mainImage,
                                            fill: true,
                                            className: "rounded-xl"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        ref: postRef,
                                        className: "mt-8 prose md:mt-12 lg:prose-lg xl:prose-xl font-inter max-w-none",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PortableText/* PortableText */.Y, {
                                            blocks: post.body
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "my-8 font-inter",
                                        children: post.citationSources && post.citationSources.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(PostCitationSources, {
                                            sources: post.citationSources
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                        className: "h-px bg-dawnDark-500 opacity-10"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-10",
                                        children: ((ref3 = post.authors) === null || ref3 === void 0 ? void 0 : ref3.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(PostAuthors, {
                                            authors: post.authors
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "py-24 md:py-38",
                        children: ((ref4 = post.readMorePosts) === null || ref4 === void 0 ? void 0 : ref4.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(PostReadMore, {
                            posts: post.readMorePosts
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToAction/* CallToAction */.J, {
                        title: "It\u2019s time to stop blaming the night monsters.",
                        text: "Let\u2019s work together to transform your sleep for the better.",
                        buttonText: "Take your sleep quiz"
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 92139:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"inputRange":"CallToActionSlider_inputRange__0IXs0"};

/***/ }),

/***/ 7297:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,9122,5329,5430,1310,4377,2595,1437,9774,2888,179], function() { return __webpack_exec__(41127); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);